<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-form-table :form.sync="form" >
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="money" slot-scope="data">
            <span>{{ $wtUtil.transMoney(data.row.money) }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerPaySettle',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      detailFormButtons: {
        title: '结算明细',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userWechat/userCustomerSettlementList' }
        },
        formInputsData: [{ name: '结算时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '用户', key: 'userId', value: 0, type: 'customAll' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXCEL',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userWechat/userCustomerSettlementListImport',
          fileName: '大客户支付结算明细' }],
        formTableData: [
          { name: '结算金额', key: 'money', type: 'custom' },
          { name: '结算时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '操作人员', key: 'employeesUserName', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '结算明细' }})
    this.form.formInputsData[1].value = this.customerId
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      customerId: state => state.userWechat.customerId
    })
  }
}
</script>
